<template>
  <form @submit.prevent.stop="invite">
    <div class="title">
      {{ modalTitle }}
    </div>
    <div class="body">
      <div v-if="isSingle">
        <div>
          <div class="form-group half">
            <label for="first-name">First Name</label>
            <input
              id="first-name"
              v-model="firstName"
              type="text"
            >
          </div>
          <div class="dg form-group half">
            <label for="last-name">Last Name</label>
            <input
              id="last-name"
              v-model="lastName"
              type="text"
            >
          </div>
        </div>
        <div class="dg form-group">
          <label for="email">Email Address</label>
          <input
            id="email"
            v-model="email"
            type="email"
            required="true"
          >
        </div>
      </div>
      <div v-else>
        <div class="dg form-group">
          <label for="email-list">Type or paste email addresses separated by commas or on separate lines.</label>
          <textarea
            id="email-list"
            v-model="emailList"
            required="true"
          />
          <div class="form-hint">
            For best performance, we recommend not pasting more than 50 emails at a time.
          </div>
        </div>
      </div>
      <div class="dg form-group">
        <label for="invitation-text">Invitation Message</label>
        <textarea
          id="invitation-text"
          v-model="invitationText"
          rows="4"
        >
          Hello Everyone,

          We created this Rally as an all-in-one solution for us to stay organized and connected. It's one easy place for us to send messages, keep a group calendar, organize special events, collect money, as well as share files, photos, links, tasks, and more. We also love that it's private, secure, and ad-free!

          Thanks for all you do!
        </textarea>
      </div>
      <div>
        <div class="dg form-group stacked-labels checkboxes">
          <label>
            <input
              v-model="saveAsDefaultInvitationText"
              type="checkbox"
            >
            <div class="square" />
            <b>Save as default invitation message</b>
          </label>
        </div>
        <div class="dg form-group inline-labels radios">
          <label>Their role in this Rally</label>
          <label>
            <input
              v-model="role"
              name="role"
              type="radio"
              value="Friend"
            >
            <div class="circle" />
            <b>Invite As Friend</b>
          </label>
          <label>
            <input
              v-model="role"
              name="role"
              type="radio"
              value="Admin"
            >
            <div class="circle" />
            <b>Invite As Admin</b>
          </label>
        </div>
      </div>
    </div>
    <div class="footer">
      <button
        class="dg secondary"
        @click="close"
      >
        Cancel
      </button>
      <button
        class="dg primary"
        type="submit"
      >
        Invite
      </button>
    </div>
  </form>
</template>

<script>
  import { mapActions, mapState } from "vuex"

  export default {
    props: {
      initialValues: {
        default: null,
        required: false,
        type: Object,
      },
      modalVariant: {
        required: true,
        type: String,
      },
      rallyId: {
        required: true,
        type: Number,
      },
    },
    data() {
      return {
        email: '',
        firstName: '',
        invitationText: '',
        lastName: '',
        role: 'Friend',
        saveAsDefaultInvitationText: false,
      }
    },
    computed: {
      ...mapState("rallies", ["allRalliesByRallyId"]),
      isSingle() {
        return this.modalVariant === 'single'
      },
      modalTitle() {
        return this.isSingle ? 'Invite someone to this Rally' : 'Send group invitations'
      },
    },
    mounted() {
      this.setupForm()
    },
    methods: {
      ...mapActions("memberships", ["createMemberInvite"]),
      ...mapActions("rallies", ["updateRally"]),
      ...mapActions("user", ["setModalProps"]),
      close() {
        this.setModalProps({})
      },
      async invite() {
        if (this.emailList && this.emailList.length > 0) {
          this.emailList = this.emailList.replace(/\n/g, ",");
          this.emailList = this.emailList.replace(/\s+/g, "");
          this.emailList = this.emailList.replace(/,+/g, ",");
          const promises = this.emailList.split(",").map(e => {
            if (e.indexOf("@") > 0 ){
              e = e.trim()
              const arr = e.split("@");
              return this.createMemberInvite({
                createdVia: 'RallyFriends',
                invitationText: this.invitationText,
                rallyId: this.rallyId,
                role: this.role,
                status: 'Invited',
                firstName: arr[0],
                lastName: arr[1],
                email: e,
                title: this.title
              });
            }
          });
          await Promise.all(promises);
        }

        if (this.email && this.email.length > 0) {
          await this.createMemberInvite({
            createdVia: 'RallyFriends',
            email: this.email.trim(),
            firstName: this.firstName,
            invitationText: this.invitationText,
            lastName: this.lastName,
            rallyId: this.rallyId,
            role: this.role,
            status: 'Invited',
          })
        }

        if (this.saveAsDefaultInvitationText) {
          const rallyDup = this.allRalliesByRallyId[this.rallyId]
          rallyDup.rally.attributes["invitation-message"] = this.invitationText
          await this.updateRally({rally: rallyDup, invitation_message: this.invitationText})
        }

        this.$store.dispatch('user/flashSuccess', 'Invitations(s) are on their way!');
        this.close();
      },
      setupForm() {
        const rally = this.allRalliesByRallyId[this.rallyId].rally
        this.invitationText = rally.attributes["invitation-message"]

        if ( this.initialValues ) {
          this.email = this.initialValues.email
          this.firstName = this.initialValues.firstName
          this.lastName = this.initialValues.lastName
        }
      },
    },
  }
</script>
